module.exports = __webpack_public_path__ + "img/click_explore_NO.fd230c7c.svg";